import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {ChallengeUser} from "../../models/challenge-user";

/**
 * Generated class for the AppChallengeUserPopupAchievedPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-challenge-user-popup-achieved',
  templateUrl: 'app-challenge-user-popup-achieved.html',
})
export class AppChallengeUserPopupAchievedPage {

  challenge: ChallengeUser;
  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.challenge = this.navParams.get('challenge');
  }

  close() {
    this.navCtrl.pop();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppChallengeUserPopupAchievedPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/app-challenge-user-popup-achieved/app-challenge-user-popup-achieved.ts